<template>
  <div v-if="info">
    <div class="pageTitleController">
      <img src="@/assets/img/7.png" />
      <div class="marginLeft15">企业信息</div>
    </div>
    <div v-if="uuid !== null" class="small smallHead fix">
      <div class="bg-white nav" scroll-with-animation>
        <div class="total ">
          <div
            v-if="agent_type === 2"
            @click="
              $router.push({
                query: {
                  type: 1,
                  id: id,
                  uuid: uuid
                },
                name: 'detail'
              })
            "
            class="sizeStyle "
            :class="type === 1 ? 'select' : ''"
          >
            <div class="size" :class="type === 1 ? 'blackStyle' : 'grayStyle'">
              经销（代理）商
            </div>
            <div v-if="type === 1" class="lineStyle blackLine"></div>
          </div>
          <div
            @click="
              $router.push({
                query: {
                  type: 2,
                  id: id,
                  uuid: uuid
                },
                name: 'detail'
              })
            "
            class="sizeStyle"
            :class="type === 2 ? 'select' : ''"
          >
            <div class="size" :class="type === 2 ? 'blackStyle' : 'grayStyle'">
              生产商信息
            </div>
            <div v-if="type === 2" class="lineStyle blackLine"></div>
          </div>
          <div
            @click="
              $router.push({
                query: {
                  uuid: uuid,
                  onlyshow: 1
                },
                name: 'ProductSave'
              })
            "
            class="sizeStyle"
          >
            <div class="size grayStyle">
              产品信息
            </div>
            <div class="lineStyle"></div>
          </div>
        </div>
      </div>
      <!-- <div class="return">返回上一级</div> -->
    </div>

    <div class="small">
      <div class="top">
        <div class="topName">审核信息</div>
        <div v-if="info.profile_step === 3" class="topBtn marginLeft15">
          驳回
        </div>
        <div v-if="info.profile_step === 4" class="topBtnBlue marginLeft15">
          审核中
        </div>
        <div v-if="info.profile_step === 1" class="topBtnBlue marginLeft15">
          待提交
        </div>
        <div
          v-if="info.profile_step === 2"
          class="topBtnBlue marginLeft15"
          style="background:rgba(0,159,48,1);"
        >
          已通过
        </div>
      </div>
      <div class="bottom">
        <div class="bottomL">
          <img
            v-if="info.profile_step === 3"
            src="@/assets/img/cha.png"
            class="icon"
          />
          <img v-else src="@/assets/img/gou.png" class="icon" />
          <div v-if="false" class="marginLeft20">
            <div class="black">抱歉您的资料未通过初审，请求修改后重新提交</div>
            <div class="red">反馈信息：上传的营业执照附件不清晰。</div>
          </div>
          <div class="marginLeft20">
            <div class="black" v-if="info.profile_step === 1">
              企业信息等待提交
            </div>
            <div class="black" v-if="info.profile_step === 2">
              恭喜，您的资料已通过审核！
            </div>
            <div class="black" v-if="info.profile_step === 3">
              信息被驳回
            </div>
            <div class="black" v-if="info.profile_step === 4">
              等待审核中
            </div>

            <div v-if="info.profile_step === 3" class="add marginTop7">
              {{ info.checkmark }}
            </div>
            <div v-else class="add marginTop7">
              暂无审批意见
            </div>
          </div>
        </div>
        <!-- <div
          v-if="info.profile_step !== 4"
          @click="
            $router.push({
              query: {
                save: 'save'
              },
              name: 'UserInfo'
            })
          "
          class="blueBtn  detailBtnSize"
        >
          修改资料
        </div> -->
      </div>
    </div>

    <Plan title="企业资质信息" class="marginTop20">
      <div class="total marginBottom37">
        <div class="item">
          <div class="title-s marginBottom16">企业名称</div>
          <div class="content">
            {{ infoForm.company_name ? infoForm.company_name : "-" }}
          </div>
        </div>
        <!-- <div class="item marginLeft40">
          <div class="title-s marginBottom16">
            委托代理企业名称（选填）
          </div>
          <div class="content">{{ info.agent_company }}</div>
        </div> -->
        <div class="item marginLeft40">
          <div class="title-s marginBottom16">
            企业类型
          </div>
          <div class="content">{{ info.cate_text }}</div>
        </div>
      </div>

      <div class="total marginBottom37">
        <div class="item">
          <div class="title-s marginBottom16">
            统一社会信用代码
          </div>
          <div class="content">{{ infoForm.social_code }}</div>
        </div>
        <div class="item marginLeft40">
          <div class="title-s marginBottom16">
            注册资金（万元）
          </div>
          <div class="content">{{ infoForm.reg_capital }}万元</div>
        </div>
        <div class="item marginLeft40">
          <div class="title-s marginBottom16">
            法定代表人
          </div>
          <div class="content">{{ infoForm.legal_name }}</div>
        </div>
      </div>

      <div class="total marginBottom37">
        <div class="item">
          <div class="title-s marginBottom16">
            法定代表人联系电话
          </div>
          <div class="content">{{ infoForm.legal_tel }}</div>
        </div>
        <div class="item marginLeft40">
          <div class="title-s marginBottom16">
            企业注册地址
          </div>
          <div class="content">
            <Areselect :onlyshow="true" v-model="areCodeList"></Areselect>
            {{ infoForm.register_address }}
          </div>
        </div>
      </div>

      <div class="total marginBottom0">
        <div class="item">
          <div class="title-s marginBottom16">
            营业执照（彩色扫描件）
          </div>
          <div class="content">
            <el-image
              :preview-src-list="[yinyezhizhao[0].viewurl]"
              v-if="yinyezhizhao.length === 1"
              class="upCoerImg"
              :src="yinyezhizhao[0].viewurl"
            />
          </div>
        </div>
        <!-- <div class="item marginLeft40">
          <div class="title-s marginBottom16">
            代理企业的代理销售授权委托书
          </div>
          <div class="content">
            <el-image
              :preview-src-list="[weituoshu[0].viewurl]"
              v-if="weituoshu.length === 1"
              class="upCoerImg"
              :src="weituoshu[0].viewurl"
            />
          </div>
        </div> -->
      </div>
    </Plan>

    <Plan title="企业通讯信息" class="marginTop20">
      <div class="total marginBottom0">
        <div class="item">
          <div class="title-s marginBottom16">
            经办人
          </div>
          <div class="content">{{ infoForm.contact_person }}</div>
        </div>
        <div class="item marginLeft40">
          <div class="title-s marginBottom16">
            经办人联系电话
          </div>
          <div class="content">{{ infoForm.contact_tel }}</div>
        </div>
        <div class="item marginLeft40">
          <div class="title-s marginBottom16">
            联系地址
          </div>
          <div class="content">{{ infoForm.contact_address }}</div>
        </div>
      </div>
    </Plan>

    <!-- 确定按钮 -->
    <div class="total Center" v-if="false">
      <el-button class="blueBorder">确认</el-button>
    </div>
    <!-- 审核按钮 -->
    <div class="total Center" v-if="false">
      <el-button class="noneBorder">提交审核</el-button>
    </div>
    <!-- <div
      v-if="info.profile_step !== 4 && info.profile_step !== 2"
      class="total Center"
    >
      <el-button
        @click="
          $router.push({
            query: {
              save: 'save'
            },
            name: 'UserInfo'
          })
        "
        class="noneBorder"
      >
        修改资料
      </el-button>
    </div> -->
  </div>
</template>
<script>
import Plan from "@/components/Plan.vue";
import Api from "@/plugins/axios.js";
import { Loading } from "element-ui";
import Areselect from "@/components/Areselect.vue";
export default {
  components: {
    Areselect,
    Plan
  },
  data() {
    return {
      agent_type: 2, // 默认是代理商信息
      uuid: null, // uuid
      id: null, // 要显示生产商信息的ID
      fenlei: [], // 企业信息分类
      info: null, // 全部详细信息
      areCodeList: [], // 三级地址下拉
      infoForm: {
        company_name: "", // 企业名称
        company_cate: "", // 企业分类
        social_code: "", // 统一社会信用代码
        reg_capital: "", // 注册资本
        legal_name: "", // 法定代表人
        legal_tel: "", // 电话
        register_address: "", // 注册地址
        contact_person: "", // 联系人
        contact_tel: "", // 联系人电话
        contact_address: "" // 联系地址
      },
      yinyezhizhao: [], // 营业执照
      weituoshu: [] // 委托书
    };
  },
  watch: {
    $route() {
      this.init();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      if (this.$route.query.id) {
        this.id = parseInt(this.$route.query.id);
      } else {
        this.id = null;
      }
      if (this.$route.query.type) {
        this.type = parseInt(this.$route.query.type);
      } else {
        this.type = null;
      }
      if (this.$route.query.uuid) {
        this.uuid = this.$route.query.uuid;
      } else {
        this.uuid = null;
      }
      const loadingInstance = Loading.service({ fullscreen: true });
      // 企业信息获得
      let info = null;
      if (this.type === 2) {
        info = await Api.getAgent(this.$store.state.token, this.id);
      } else {
        info = await Api.userinfo(this.$store.state.token);
      }
      this.info = info;

      // 处理三级下拉选择器
      if (info) {
        let arr = [];
        if (info.province_code) {
          arr[0] = info.province_code;
        }
        if (info.city_code) {
          arr[1] = info.city_code;
        }
        if (info.area_code) {
          arr[2] = info.area_code;
        }
        this.areCodeList = arr;
        console.log("三级下拉", this.areCodeList);
      } else {
        this.areCodeList = [];
      }

      this.infoForm = {
        company_name: info.company_name, // 企业名称
        company_cate: info.company_cate, // 企业分类
        social_code: info.social_code, // 统一社会信用代码
        reg_capital: info.reg_capital, // 注册资本
        legal_name: info.legal_name, // 法定代表人
        legal_tel: info.legal_tel, // 电话
        register_address: info.register_address, // 注册地址
        contact_person: info.contact_person, // 联系人
        contact_tel: info.contact_tel, // 联系人电话
        contact_address: info.contact_address // 联系地址
      };
      if (info.business_license) {
        this.yinyezhizhao = [
          {
            name: "",
            url: info.business_license,
            viewurl: Api.domain + info.business_license
          }
        ];
      } else {
        this.yinyezhizhao = [];
      }
      if (info.agent_attorney) {
        this.weituoshu = [
          {
            name: "",
            url: info.agent_attorney,
            viewurl: Api.domain + info.agent_attorney
          }
        ];
      } else {
        this.weituoshu = [];
      }
      // 企业分类
      const li = await Api.getQyFl("business_class", 0);
      this.fenlei = li;

      // 产品信息获得
      if (this.uuid) {
        const chanpingInfo = await Api.infodetail(
          this.$store.state.token,
          this.uuid
        );

        // 计算类型
        this.agent_type = parseInt(chanpingInfo.agent_type);
        console.log("显示模式类型", this.agent_type);
      }

      loadingInstance.close();
    }
  }
};
</script>
<style lang="less" scoped>
.el-upload__tip {
  font-size: 12px;
  font-weight: 400;
  color: rgba(204, 204, 204, 1);
}
//蓝色上传按钮
.el-button {
  width: 120px;
  height: 32px;
  background: #0082a4 !important;
  opacity: 1;
  border-radius: 2px;
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}
.blueBorder {
  width: 200px;
  height: 40px;
  border: 1px solid rgba(0, 130, 164, 1);
  opacity: 1;
  border-radius: 20px;
  background: rgba(0, 0, 0, 0) !important;
  font-size: 16px;
  font-weight: 400;
  color: rgba(0, 130, 164, 1);
  margin-top: 20px;
}
.noneBorder {
  width: 200px;
  height: 40px;
  border: 1px solid rgba(0, 130, 164, 1);
  opacity: 1;
  border-radius: 20px;
  background: rgba(0, 130, 164, 1) !important;
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  margin-top: 20px;
}
.content {
  display: relative;
  width: 320px;
  font-size: 12px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  .del {
    position: absolute;
    right: 0px;
    top: 0px;
    font-size: 22px;
    color: red;
  }
}
.logo {
  width: 120px;
  height: 120px;
}
.Center {
  justify-content: center;
}
.back {
  background-color: #e4edf8;
  padding-top: 25px;
  padding-left: 25px;
  padding-right: 83px;
}
.backName {
  font-size: 28px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.remarkBox {
  padding-left: 38px;
  padding-right: 38px;
  width: 100%;
  border-radius: 4px;
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 10px rgba(151, 190, 255, 0.17);
}
.remarkL {
  font-size: 14px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}
.remarkR {
  font-size: 14px;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  margin-left: 40px;
}
.marT20 {
  margin-top: 20px;
}
.marT40 {
  margin-top: 40px;
}
.cont {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 10px rgba(151, 190, 255, 0.17);
  border-radius: 4px;
  padding-top: 22px;
  padding-left: 33px;
  padding-right: 33px;
  padding-bottom: 52px;
}
.contName {
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  color: rgba(51, 51, 51, 1);
}
.contItem {
  display: flex;
  margin-top: 30px;
}
.contL {
  font-size: 14px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  opacity: 1;
  width: 150px;
  text-align: right;
}
.contR {
  margin-left: 20px;
  font-size: 14px;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  opacity: 1;
}
.contGray {
  margin-left: 13px;
  font-size: 12px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  opacity: 1;
}
.detailBtn {
  display: flex;
  justify-content: flex-start;
}
.marL20 {
  margin-left: 20px;
}

.detailBtnSize {
  padding: 10px 35px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  border-radius: 100px;
}
.grayBtn {
  background: rgba(204, 204, 204, 1);
}
.blueBtn {
  cursor: pointer;
  background: #0082a4;
}
.small {
  margin-top: 20px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 10px rgba(151, 190, 255, 0.17);
}
.return {
  right: 25px;
  top: 17px;
  position: absolute;
  font-size: 12px;
  font-weight: 400;
  color: rgba(29, 120, 211, 1);
}
.top {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
  align-items: center;
  padding-top: 18px;
  padding-bottom: 8px;
  padding-left: 38px;
  border-bottom: 1px solid rgba(230, 230, 230, 1);
}
.topBtn {
  margin-left: 18px;
  padding-left: 5px;
  padding-right: 5px;
  background: rgba(255, 0, 0, 1);
  opacity: 1;
  border-radius: 7px;
  text-align: center;
  font-size: 10px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  height: 14px;
}
.add {
  font-size: 12px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}
.topName {
  font-size: 16px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.bottom {
  padding: 30px 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.bottomL {
  display: flex;
}
.icon {
  width: 40px;
  height: 40px;
}
.black {
  font-size: 12px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.red {
  margin-top: 6px;
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 0, 0, 1);
}
.line {
  background-color: #fafafd;
  height: 10upx;
}
.fix {
  position: relative !important;
}
.total {
  display: flex;
  padding-top: 14px;
  border-bottom: 1upx solid #e5e5e5;
}
.topBtnBlue {
  width: 52px;
  height: 14px;
  background: rgba(0, 130, 164, 1);
  opacity: 1;
  border-radius: 7px;
  font-size: 10px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-align: center;
}
.size {
  font-size: 16px;
  text-align: center;
  padding-left: 38px;
  padding-right: 38px;
  margin-bottom: 14px;
}

.blackStyle {
  font-weight: normal;
  color: rgba(0, 130, 164, 1);
}

.grayStyle {
  font-weight: normal;
  color: rgba(153, 153, 153, 1);
}

.lineStyle {
  width: 82px;
  height: 2px;
  margin: auto;
}

.blackLine {
  background: rgba(0, 130, 164, 1);
}
.contItem {
  width: 1200px;
}
.itemBlues {
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-top: 14px;
  padding-bottom: 14px;
  padding-left: 38px;
  padding-right: 30px;
  background: rgba(220, 232, 255, 1);
  box-shadow: 0px 3px 10px rgba(151, 190, 255, 0.17);
  opacity: 1;
  border-radius: 4px;
}
.numbers {
  font-size: 16px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  opacity: 1;
  flex: 1;
}
.cha {
  width: 14px;
  height: 8px;
}
.itemWhite {
  width: 1200px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 10px rgba(151, 190, 255, 0.17);
  opacity: 1;
  border-radius: 4px;
  padding-bottom: 15px;
  padding-left: 39px;
  padding-right: 39px;
}
.whiteHead {
  font-size: 14px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  opacity: 1;
  margin-top: 20px;
}
.whiteCont {
  margin-top: 15px;
  font-size: 14px;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  height: 150px;
}
.lines {
  width: 100%;
  height: 1px;
  border: 1px solid rgba(230, 230, 230, 1);
}
.whiteFoot {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 10px rgba(230, 230, 230, 1);
  border-radius: 4px;
  width: 1200px;
  padding-left: 35px;
  padding-right: 35px;
  padding-bottom: 10px;
}
.footText {
  padding-top: 17px;
  padding-bottom: 17px;
}
table tr td {
  border: 1px solid rgba(230, 230, 230, 1);
  border-collapse: collapse;
  text-align: center;
  padding-top: 15px;
  padding-bottom: 15px;
}
.table {
  border: none;
}
.view {
  display: flex;
  flex: 1;
  justify-content: center;
}
</style>
